<template>
  <div class="stack" :style="{height:height}">
  </div>
</template>

<script>
export default {
  name: "Stack",
  props:{
    height:{
      type:String,
      default:'1rem'
    },    
  },
}
</script>


<style scoped>
.stack {
  position: relative;
  width:100%;
  background-color:transparent;
}
</style>
